import classnames from "classnames/bind";
import { useTranslation } from "next-i18next";
import React from "react";

import { useIsArcade } from "@/hooks/useIsArcade";

import { LocationProps } from "../../interfaces/locations/location-interface";
import { concatAddress } from "../../utils/strings";
import { KINDS, SIZES } from "../buttons/buttons.constants";
import LinkButton from "../buttons/link-button";
import styles from "./instore.module.scss";

const cx = classnames.bind(styles);

export interface Props {
    location: LocationProps;
}

export const InStoreInfoWindow: React.FC<Props> = (props: Props) => {
    const {
        location: { shopName, fullAddress, distanceToUser, newLogoUrl, shopUrl, storeName },
    } = props;
    const { t } = useTranslation();
    const isArcade = useIsArcade();

    const linkButtonprops = {
        kind: KINDS.BLACK,
        size: SIZES.SMALL,
        label: t("inStore.tile.directions"),
        url: concatAddress(fullAddress),
        newTab: true,
    };

    const instoreTileNameClassName = cx({
        [styles.instoreTileName]: !isArcade,
        [styles.instoreTileNameArcade]: isArcade,
    });
    const instoreTileAddressClassName = cx({
        [styles.instoreAddress]: true,
    });

    return (
        <div className={styles.infoWindowContainer}>
            <div className={styles.instoreTileImageContainer}>
                <img alt={shopName} className={styles.instoreTileImage} src={newLogoUrl} />
                <div className={instoreTileNameClassName}>{storeName}</div>
            </div>
            <div className={styles.instoreTileInfoContainer}>
                <div className={styles.instoreTileUpperSection}>
                    <div className={styles.instoreTileNameContainer}>
                        <div className={instoreTileNameClassName}>{shopName}</div>
                        {distanceToUser && (
                            <span className={styles.instoreTileDistance}>{distanceToUser}</span>
                        )}
                    </div>
                    <p className={instoreTileAddressClassName}>{fullAddress}</p>
                </div>
                <div className={styles.instoreTileLowerSection}>
                    <LinkButton
                        kind={KINDS.UNSET}
                        size={SIZES.UNSET}
                        label={t("inStore.tile.website")}
                        url={shopUrl}
                        newTab={true}
                    />
                </div>
            </div>
            <div className={styles.instoreTileDirectionsContainer}>
                <LinkButton {...linkButtonprops} />
            </div>
        </div>
    );
};
